import React from "react";
import "react-quill/dist/quill.snow.css";

/**
 * Renders Quill HTML with the same typography / alignment as the editor.
 */
export default function QuillHtmlDisplay({ html, className = "", style = {} }) {
  if (!html) return null;

  return (
    <div className={`ql-snow quill-html-display-wrap ${className}`.trim()} style={style}>
      <div className="ql-editor quill-html-display" dangerouslySetInnerHTML={{ __html: html }} />
    </div>
  );
}
